
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ProductPageV4_RauT40kmBYMI47BxHz1LcQIRDSK9PL0YrhPBq55IMeta } from "/builds/macys/polaris/nuxt-app/pdp/app/pages/ProductPage.vue?macro=true";
import { default as DevPlaygroundggpA6LcXNztJBdTfzY84Y1mB8OXDw_aJJ770NrK_57UMeta } from "/builds/macys/polaris/nuxt-app/pdp/app/pages/DevPlayground.vue?macro=true";
import { default as WriteReviewPageWiFxXrCT4Ok_7VfUMeyFEtrWgJWhZ_x4TmZTV7sBr0kMeta } from "/builds/macys/polaris/nuxt-app/pdp/app/pages/WriteReviewPage.vue?macro=true";
export default [
  {
    name: "ProductPage",
    path: "/ProductPage",
    component: () => import("/builds/macys/polaris/nuxt-app/pdp/app/pages/ProductPage.vue")
  },
  {
    name: "DevPlayground",
    path: "/DevPlayground",
    component: () => import("/builds/macys/polaris/nuxt-app/pdp/app/pages/DevPlayground.vue")
  },
  {
    name: "WriteReviewPage",
    path: "/WriteReviewPage",
    component: () => import("/builds/macys/polaris/nuxt-app/pdp/app/pages/WriteReviewPage.vue")
  }
]